import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  Sgke111aRequest, Sgke111aResponseInitialhyojiInfo, Sgke112aRequest,
  Sgke112aResponseGamenHyojiInfo, Sgke112aResponseInitialhyojiInfo,
  Sgke113aRequest, Sgke114aRequest, Sgke115aRequest
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgkz004dComponent } from '../../../../../../sg-base/sg-base-shared/pages/sgkz004d/components/sgkz004d.component';
import { UsedSgke111aService } from '../../services/used-sgke111a.service';
import { UsedSgke112aService } from '../../services/used-sgke112a.service';
import { UsedSgke113aService } from '../../services/used-sgke113a.service';
import { UsedSgke114aService } from '../../services/used-sgke114a.service';
import { UsedSgke115aService } from '../../services/used-sgke115a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke110d',
  templateUrl: './sgke110d.component.html',
  styleUrl: './sgke110d.component.scss'
})
export class Sgke110dComponent implements OnInit, OnDestroy {

  /** モーダル表示フラグ */
  @Input() isMordal: boolean = false;
  /** 編集フラグ */
  @Input() isEdit: boolean = false;
  /** 入金通知報告管理番号 */
  @Input() rcvmnyNotificationreportMno: string = null;
  /** 入金通知報告履歴番号 */
  @Input() rcvmnyNotificationreportRrkno: string = null;
  /** 入金突合結果管理番号 */
  @Input() rcvmnyReconciliationresultMno: string = null;
  /** 入金通知報告_更新通番号 */
  @Input() rcvmnyNotificationreportUpdatesequencenumber: string = null;
  /** 入金突合結果_更新通番号 */
  @Input() rcvmnyreconciliationResultUpdatesequencenumber: string = null;

  /** 【モーダル確認】モーダルボタン押下 */
  @Output() clickMordalEvent = new EventEmitter();
  /** ダイアログクローズイベント*/
  @Output() dialogCloseEmitter = new EventEmitter();
  /**  メッセージリスト */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 初期表示（新規）APIリクエスト */
  private request111a: Sgke111aRequest;
  /** 初期表示（訂正）APIリクエスト */
  private request112a: Sgke112aRequest;

  /** 初期表示情報（新規）_検索結果 */
  newInitialhyojiInfo: Sgke111aResponseInitialhyojiInfo;
  /** 初期表示情報（訂正）_検索結果 */
  correctionInitialhyojiInfo: Sgke112aResponseInitialhyojiInfo;
  /** 画面表示情報（訂正）_検索結果 */
  gamenHyojiInfo: Sgke112aResponseGamenHyojiInfo;
  /** 入金通知報告登録APIリクエストDto FormGroup */
  regInfRequestForm: UntypedFormGroup;
  /** FormGroupDirective */
  private formGroupDirective: FormGroupDirective;

  /**
   * コンストラクタ
   * @param {UsedSgke111aService} newSearchService
   * @param {UsedSgke112aService} correctionSearchService
   * @param {UsedSgke113aService} newRegistService
   * @param {UsedSgke114aService} correctionRegistService
   * @param {UsedSgke115aService} deleteService
   * @param {MatDialog} dialog
   * @param {UntypedFormBuilder} fb
   * @param {ChangeDetectorRef} cd
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke110dComponent
   */
  constructor(public newSearchService: UsedSgke111aService,
    public correctionSearchService: UsedSgke112aService,
    public newRegistService: UsedSgke113aService,
    public correctionRegistService: UsedSgke114aService,
    public deleteService: UsedSgke115aService,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    public responseMsgUtils: ResponseMsgUtils,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke110dComponent
   */
  ngOnInit(): void {
    this.init()
  }

  /**
   * 購読解除
   * @memberof Sgke110dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 登録処理
   * @memberof Sgke110dComponent
   */
  regist(formDirective: FormGroupDirective) {
    this.clearErrorMsg();
    this.formGroupDirective = formDirective;

    if (this.isEdit) {

      const updateInfoGroup = this.regInfRequestForm.controls['updateInfo'] as FormGroup;

      let befteiseiInmnyCtrl = updateInfoGroup.controls['befteiseiInmny'];
      befteiseiInmnyCtrl.enable();

      let request = this.regInfRequestForm.value as Sgke114aRequest;

      // 非活性に戻す
      befteiseiInmnyCtrl.disable();

      // SGKE114A呼び出し
      this.correctionRegistService.doSgke114a(request)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          this.handleResponse,
          error => {
          });
    } else {

      // Form情報をリクエスト用に変換
      this.convertFormToRequestData();

      let request = this.regInfRequestForm.value as Sgke113aRequest;

      // リクエスト用に変換したForm情報を戻す
      this.convertRequestToFormData();

      // SGKE113A呼び出し
      this.newRegistService.doSgke113a(request)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          this.handleResponse,
          error => {
          }
        );
    }
  }

  /**
   * 削除処理
   * @memberof Sgke110dComponent
   */
  remove() {

    this.clearErrorMsg();

    const updateInfoGroup = this.regInfRequestForm.controls['updateInfo'] as FormGroup;
    let afteiseiInmnyCtrl = updateInfoGroup.controls['afteiseiInmny'];
    afteiseiInmnyCtrl.disable();

    let requestData = this.regInfRequestForm.value as Sgke114aRequest;

    // 活性状態に戻す
    afteiseiInmnyCtrl.enable();

    const request: Sgke115aRequest = {
      requestCommon: requestData.requestCommon,
      delInfo: requestData.updateInfo,
    }

    // SGKE115A呼び出し
    this.deleteService.doSgke115a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleResponse,
        error => {
        }
      );
  }

  /**
   * キャンセル処理
   * @memberof Sgke110dComponent
   */
  cancel() {
    this.clearErrorMsg();
    this.dialogCloseEmitter.emit();
  }

  /**
   * アイコン押下処理
   * @memberof Sgke110dComponent
   */
  onClickIcon() {
    // 実行履歴情報画面モーダルを表示
    this.dialog.open(Sgkz004dComponent, {
      disableClose: true, // 背景クリックのクローズ禁止
      data: {
        // 履歴管理グループ OT_SGKERNR（入金通知報告）を設定
        historyManagementGroup: 'OT_SGKERNR',
        // 履歴管理キー 入金通知報告管理番号を設定
        historyManagementKey: this.rcvmnyNotificationreportMno,
        // 承認欄表示フラグに'0'（承認者欄を非表示）を設定
        apprvOnFlg: '0'
      },
    });
  }

  /**
   * 初期表示（新規）_検索処理
   * @private
   */
  private newInitSearch() {
    // sgke111aのリクエスト情報をもつオブジェクトを定義
    this.request111a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      hikitsugiInfo: {
        rcvmnyNotificationreportMno: this.rcvmnyNotificationreportMno,
        rcvmnyNotificationreportRrkno: this.rcvmnyNotificationreportRrkno,
        rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
        rcvmnyreconciliationResultUpdatesequencenumber: this.rcvmnyreconciliationResultUpdatesequencenumber,
      }
    };

    // SGKE111A呼び出し
    this.newSearchService.doSgke111a(this.request111a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.initialhyojiInfo) {
          this.newInitialhyojiInfo = response.initialhyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * 初期表示（訂正）_検索処理
   * @private
   * @memberof Sgke110dComponent
   */
  private correctionInitSearch() {
    // sgke112aのリクエスト情報をもつオブジェクトを定義
    this.request112a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      shtkInfo: {
        rcvmnyNotificationreportMno: this.rcvmnyNotificationreportMno,
        rcvmnyNotificationreportRrkno: this.rcvmnyNotificationreportRrkno,
        rcvmnyReconciliationresultMno: this.rcvmnyReconciliationresultMno,
        rcvmnyNotificationreportUpdatesequencenumber: this.rcvmnyNotificationreportUpdatesequencenumber,
        rcvmnyreconciliationResultUpdatesequencenumber: this.rcvmnyreconciliationResultUpdatesequencenumber,
      }
    };

    // SGKE112A呼び出し
    this.correctionSearchService.doSgke112a(this.request112a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.initialhyojiInfo) {
          this.correctionInitialhyojiInfo = response.initialhyojiInfo;
          this.gamenHyojiInfo = response.gamenHyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke110dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response 
   * @memberof Sgke110dComponent
   */
  private handleResponse = (response: any): void => {
    if (response) {
      if (this.isMordal) {
        this.dialogCloseEmitter.emit(response?.responseCommon?.errors);
      } else {
        // メッセージ表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        if (this.formGroupDirective) {
          this.formGroupDirective.resetForm();
        }
        // 初期表示処理
        this.init();
      }
    }
  }


  /**
   * 初期表示処理
   * @memberof Sgke110dComponent
   */
  private init(): void {
    this.newInitialhyojiInfo = null
    this.correctionInitialhyojiInfo = null;

    // 登録情報のFormを初期化
    this.regInfRequestForm = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });

    if (this.isMordal) {
      // モーダル画面の場合
      this.correctionInitSearch();
    } else {
      // メニュー画面の場合
      this.newInitSearch();
    }

  }

  /**
   * フォーム情報をリクエスト用に変換する
   * @private
   * @memberof Sgke140dComponent
   */
  private convertFormToRequestData() {
    const regInfFormGroup = this.regInfRequestForm.controls['reginf'] as FormGroup;
    if (this.isMordal) {
      // 会社を活性化
      regInfFormGroup.controls['companycode'].enable();
      // 入金地区を活性化
      regInfFormGroup.controls['rcvmnyAreacode'].enable();
      // 口座入金日を活性化
      regInfFormGroup.controls['kouzaRcvmnyYearmonthdate'].enable();
      // 入金口座を活性化
      regInfFormGroup.controls['rcvmnyKouzacode'].enable();
      // 入金形態を活性化
      regInfFormGroup.controls['rcvmnyKeitaiCode'].enable();
      // 口座入金機関を活性化
      regInfFormGroup.controls['kouzaRcvmnyBankofficecode'].enable();
    }
  }


  /**
   * リクエスト用に変換したフォーム情報を戻す
   * @private
   * @memberof Sgke140dComponent
   */
  private convertRequestToFormData() {
    const regInfFormGroup = this.regInfRequestForm.controls['reginf'] as FormGroup;
    if (this.isMordal) {
      // 会社を非活性化
      regInfFormGroup.controls['companycode'].disable();
      // 入金地区を非活性化
      regInfFormGroup.controls['rcvmnyAreacode'].disable();
      // 口座入金日を非活性化
      regInfFormGroup.controls['kouzaRcvmnyYearmonthdate'].disable();
      // 入金口座を非活性化
      regInfFormGroup.controls['rcvmnyKouzacode'].disable();
      // 入金形態を非活性化
      regInfFormGroup.controls['rcvmnyKeitaiCode'].disable();
      // 口座入金機関を非活性化
      regInfFormGroup.controls['kouzaRcvmnyBankofficecode'].disable();
    }
  }
}
